import { render, staticRenderFns } from "./clientesEspecificos.vue?vue&type=template&id=588bf582&scoped=true"
import script from "./clientesEspecificos.vue?vue&type=script&lang=js"
export * from "./clientesEspecificos.vue?vue&type=script&lang=js"
import style0 from "./clientesEspecificos.vue?vue&type=style&index=0&id=588bf582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588bf582",
  null
  
)

export default component.exports